import { render, staticRenderFns } from "./Qxc.vue?vue&type=template&id=648445ba&scoped=true"
import script from "./Qxc.vue?vue&type=script&lang=js"
export * from "./Qxc.vue?vue&type=script&lang=js"
import style0 from "./Qxc.vue?vue&type=style&index=0&id=648445ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648445ba",
  null
  
)

export default component.exports